// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorWrapper_wrapper__17a50","icon":"ErrorWrapper_icon__b5rHo","title":"ErrorWrapper_title__47XZo","description":"ErrorWrapper_description__U_oR2"};